/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const getIRAContributionLimit = (state) => state.iraContributionLimit;

export const getIRAContributionPeriod = (state) => state.iraContributionPeriod;
